import React from "react";
import {Route, Redirect} from "react-router-dom";
import {useAuth} from "../../services/use-auth";


function isProfileIncomplete(user) {
    if (!user) return false;
    const first = user.firstName;
    const last = user.lastName;
    return !first || !last;
}

/**
 * Використання:
 * <GuardedRoute path="/dashboard" component={Dashboard} authRequired profileFillRequired />
 * <GuardedRoute path="/about" component={About} />
 */
export default function GuardedRoute({
                                         component: Component,
                                         authRequired = false,
                                         profileFillRequired = true,
                                         children,
                                         ...rest
                                     }) {
    const auth = useAuth();
    const user = auth?.user || null;

    return (
        <Route
            {...rest}
            render={(routeProps) => {
                const {location} = routeProps;

                if (auth?.loading) {
                    return <div>Loading...</div>;
                }

                // 1️⃣ Якщо потрібна авторизація, але користувача немає — редіректимо
                if (authRequired && !user) {
                    return (
                        <Redirect
                            to={{pathname: "/account/login", state: {from: location}}}
                        />
                    );
                }

                // 2️⃣ Якщо потрібно мати заповнений профіль, а даних нема — редіректимо
                if (profileFillRequired && user && isProfileIncomplete(user)) {
                    return (
                        <Redirect
                            to={{pathname: "/profile/complete", state: {from: location}}}
                        />
                    );
                }

                // 3️⃣ Інакше — показуємо children або component
                if (Component) {
                    return <Component {...routeProps} />;
                }
                return typeof children === "function" ? children(routeProps) : children;
            }}
        />
    );
}
